/** Package links — create view (append-only; no edit). */
import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import {
  LINK_TYPES,
  createPackageLinkSchema,
  type CreatePackageLinkInput,
} from "@aos/shared";

import { FormShell } from "../skills/_components/FormShell";
import {
  optionsFromEnum,
  SelectField,
  TextAreaField,
  TextField,
} from "../skills/_components/form";

export function PackageLinkCreate() {
  const form = useForm<CreatePackageLinkInput>({
    resolver: zodResolver(createPackageLinkSchema),
    refineCoreProps: { resource: "package-links", action: "create" },
  });

  const {
    refineCore: { onFinish, formLoading },
    handleSubmit,
  } = form;

  return (
    <FormShell
      title="New Package Link"
      resource="package-links"
      isSubmitting={formLoading}
      onSubmit={handleSubmit((values) => onFinish(values))}
    >
      <TextField
        form={form}
        name="source_package_id"
        label="Source Package ID"
        placeholder="pkg_… (the linking package)"
      />
      <SelectField
        form={form}
        name="link_type"
        label="Link Type"
        options={optionsFromEnum(LINK_TYPES)}
      />
      <TextField
        form={form}
        name="target_package_id"
        label="Target Package ID"
        placeholder="pkg_… (the linked-to package)"
      />
      <TextAreaField
        form={form}
        name="description"
        label="Description"
        placeholder="Why these packages are linked (optional)"
        rows={2}
      />
    </FormShell>
  );
}

export default PackageLinkCreate;
